function currentHyzUser() {
    const cuser = JSON.parse(localStorage.getItem('nrsllradm'));
    return cuser
}


export const hyzuzr = {
    currentHyzUser
};
